const space = [
  '0px', // 0
  '5px', // 1
  '8px', // 2
  '10px', // 3
  '12px', // 4
  '15px', // 5
  '18px', // 6
  '20px', // 7
  '25px', // 8
  '30px', // 9
  '35px', // 10
  '40px', // 11
  '45px', // 12
  '50px', // 13
  '55px', // 14
  '60px', // 15
  '65px', // 16
  '70px', // 17
  '80px', // 18
  '85px', // 19
  '100px', // 20
  '140px', // 21
  '190px', // 22
];

export default space
